import { observable, action, runInAction, computed } from "mobx";
import { IApiClient } from "../common/api.client";
import { Layout } from "../common/webapicall";

export class LayoutStore {
	constructor(private apiClient: IApiClient) { }

	@observable isLayoutLoaded: boolean = false;
	@observable siteLayout: Layout = null;
	@observable areScriptsAdded: boolean = false;

	@action
	async getSiteLayout() {
		const response = await this.apiClient.layoutClient.getSiteLayout();
		runInAction(() => {
			if (response) {
				this.siteLayout = response;
				this.isLayoutLoaded = true;
			}
		});
	}

	@computed get CIHHeaderMarkup() {
		return { __html: this.siteLayout?.headerHtmlEncode ? window.atob(this.siteLayout.headerHtmlEncode) : "" };
	}
	@computed get CIHFooterMarkup() {
		return { __html: this.siteLayout?.footerHtmlEncode ? window.atob(this.siteLayout.footerHtmlEncode) : "" };
	}
	@computed get styleSheetUrl() {
		return this.siteLayout?.styleURL ? window.atob(this.siteLayout.styleURL) : "";
	}
	@computed get scriptUrl() {
		return this.siteLayout?.scriptUrl;
	}
	@computed get scriptPluginsURL() {
		return this.siteLayout?.scriptPluginsURL;
	}
	@action
	setAreScriptsAdded(value: boolean) {
		this.areScriptsAdded = value;
	}
}
